<template lang="pug">
  v-card.mb-4(flat)
    v-card-title
      div
        h4 Вопрос к заданию \#{{ index + 1 }}
        v-text-field.search-field(
          v-model="value.ordinal"
          outlined dense
          type="number"
          label="Порядковый номер"
        )
      v-spacer
      v-btn(@click="$emit('remove')" icon)
        v-icon mdi-close
    v-card-text
      validation-observer
        v-form(ref="form")
          validation-provider(
            rules="required|max:20000"
            name="Название"
            vid="title"
            v-slot="{ errors, valid }"
          )
            v-textarea(
              v-model="value.title"
              name="title"
              auto-grow
              rows="2"
              row-height="20"
              label="Название"
              :error-messages="errors"
              filled
              small
              rounded
              :counter="20000"
              @change="$emit('change')"
            )
          rich-text-editor.pb-4(
            v-model="value.description"
            name="description"
            label="Описание"
            vid="description"
            filled
            rounded
            :counter="2000"
            @change="$emit('change')"
          )
          //- validation-provider(
          //-   name="Описание"
          //-   rules="max:2000"
          //-   vid="description"
          //-   v-slot="{ errors, valid }"
          //- )
          //-   v-textarea(
          //-     v-model="value.description"
          //-     name="description"
          //-     label="Описание"
          //-     :error-messages="errors"
          //-     filled
          //-     small
          //-     rounded
          //-     :counter="2000"
          //-     @change="$emit('change')"
          //-   )
          validation-provider(
            name="Комментарий для обучающегося, неправильно ответившего на вопрос"
            rules="max:2000"
            vid="comment"
            v-slot="{ errors, valid }"
          )
            v-textarea.mt-4(
              v-model="value.comment"
              name="comment"
              label="Комментарий для обучающегося, неправильно ответившего на вопрос"
              :error-messages="errors"
              filled
              small
              auto-grow
              rounded
              row-height="10"
              :counter="2000"
              @change="$emit('change')"
            )
          validation-provider(
            rules="required"
            name="Тип"
            vid="type"
            v-slot="{ errors, valid }"
          )
            v-select(
              v-model="value.type"
              :items="unitTypesList"
              name="type"
              item-text="title"
              item-value="value"
              label="Тип"
              @change="$emit('change')"
              :error-messages="errors"
              filled
              rounded
            )
          div(v-if="value.type === TASK_UNIT_TYPE_NAMES.code")
            code-editor

          div(
            v-if=`value.type === TASK_UNIT_TYPE_NAMES.choiceOneOption
               || value.type === TASK_UNIT_TYPE_NAMES.choiceSeveralOptions
               || value.type === TASK_UNIT_TYPE_NAMES.shortAnswer`
          )
            v-subheader.mb-5
              .text-h6 Ответы
              v-divider.mx-3
              v-btn(
                @click="addPossibleAnswer"
                color="primary"
                rounded
                depressed
              )
                v-icon mdi-plus
                span.ml-2.d-none.d-sm-block Добавить вариант ответа
            validation-observer(v-for="(answer, i) in value.possible_answers" :key="i")
              v-row
                v-col(cols="auto")
                  validation-provider(
                    vid="possible_answers.correct_answer"
                    v-slot="{ errors, valid }"
                  )
                    v-checkbox(
                      v-model="answer.correct_answer"
                      :disabled="isAnswerDisabled(answer)"
                      name="type"
                      @change="$emit('change')"
                      label="Верный"
                      :error-messages="errors"
                      filled
                      rounded
                    )
                v-col
                  validation-provider(
                    rules="required"
                    name="Вариант ответа"
                    vid="possible_answers.name"
                    v-slot="{ errors, valid }"
                  )
                    v-textarea(
                      v-model="answer.name"
                      auto-grow
                      rows="2"
                      row-height="20"
                      name="possible_answers.name"
                      label="Вариант ответа"
                      :error-messages="errors"
                      @change="$emit('change')"
                      filled
                      dense
                      rounded
                    )
                v-col(cols="auto")
                  validation-provider(
                    rules="required|min_value:0"
                    name="Стоимость ответа"
                    vid="possible_answers.cost"
                    v-slot="{ errors, valid }"
                  )
                    v-text-field(
                      v-model="answer.cost"
                      name="possible_answers.cost"
                      label="Стоимость ответа"
                      @change="$emit('change')"
                      :error-messages="errors"
                      filled
                      dense
                      type="number"
                      rounded
                    )
                v-col(cols="auto")
                  v-btn(v-if="value.possible_answers.length > 1"
                    @click="removePossibleAnswer(i)"
                    class="mt-2"
                    color="error"
                    icon
                  )
                    v-icon mdi-close
          v-expand-transition
            template(v-if="notExistsPossibleAnswers")
              p.caption.error--text Выберите хотя бы 1 верный ответ из списка
</template>

<script>
import { TASK_UNIT_TYPES, TASK_UNIT_AUTOTEST_TYPES, TASK_UNIT_TYPE_NAMES } from '@/modules/Tasks/TaskUnits/constants';

import RichTextEditor from '@/components/InputFields/RichTextEditor.vue';
import CodeEditor from '@/components/InputFields/CodeEditor.vue';

export default {
  name: 'TaskUnitCreate',
  components: {
    CodeEditor,
    RichTextEditor,
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    index: {
      type: Number,
      default: 0,
    },
    autotest: { type: Boolean, default: false },
  },
  data: () => ({
    data: 0,
    TASK_UNIT_TYPE_NAMES,
  }),
  computed: {
    isPossibleAnwersType() {
      return [
        TASK_UNIT_TYPE_NAMES.choiceSeveralOptions,
        TASK_UNIT_TYPE_NAMES.choiceOneOption,
      ].includes(this.value.type);
    },
    // validation check
    notExistsPossibleAnswers() {
      if (!this.isPossibleAnwersType) return false;
      return !this.value.possible_answers.find((i) => i.correct_answer === true);
      // if (this.value.possible_answers > 1)
      // if (!this.value.possible_answers) return false;
    },
    unitTypesList() {
      if (this.autotest) return TASK_UNIT_AUTOTEST_TYPES;
      return TASK_UNIT_TYPES;
    },
  },
  watch: {
    // eslint-disable-next-line func-names
    'value.type': function () {
      this.$delete(this.value, 'possible_answers');

      if (this.isPossibleAnwersType) {
        this.$set(this.value, 'possible_answers', []);
        // eslint-disable-next-line
        this.value.possible_answers.push({ name: '', correct_answer: true, cost: 0 });
      }
    },
    value: {
      handler() {
        this.$emit('update');
      },
      deep: true,
    },
  },
  methods: {
    addPossibleAnswer() {
      if (!this.value.possible_answers) {
        this.$set(this.value, 'possible_answers', []);
      }
      if (this.value.type === TASK_UNIT_TYPE_NAMES.shortAnswer) {
        // eslint-disable-next-line
        this.value.possible_answers.push({ name: '', correct_answer: true, cost: 0 });
      } else {
        // eslint-disable-next-line
        this.value.possible_answers.push({ name: '', correct_answer: false, cost: 0 });
      }
    },
    removePossibleAnswer(index) {
      // eslint-disable-next-line
      this.value.possible_answers.splice(index, 1);
      if (!this.value.possible_answers.length) this.$delete(this.value, 'possible_answers');
    },
    isAnswerDisabled(answer) {
      if (this.value.type === TASK_UNIT_TYPE_NAMES.choiceOneOption) {
        return this.value.possible_answers.some((e) => e.correct_answer) && !answer.correct_answer;
      }
      return this.value.type === TASK_UNIT_TYPE_NAMES.shortAnswer;
    },
  },
};
</script>
